import {useContext, useState, useEffect} from "react";
import Orders from "../Orders/Orders";
import {SocketContext} from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import {useLocation, useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import VendorContext from "../../../contexts/VendorContext";

type Props = {
    isQuotes?: boolean;
    isTemplates?: boolean;
};

export const OrdersWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!;

    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const uiContext = useContext(UiContext);

    const navigate = useNavigate();
    const location = useLocation();
    const intl = useIntl();

    const [currentViewType, setCurrentViewType] = useState('');

    useEffect(() => {
        if (location.pathname.includes("/quotes")) {
            setCurrentViewType("quotes");
        } else if (location.pathname.includes("/templates")) {
            setCurrentViewType("templates");
        } else {
            setCurrentViewType("orders");
        }
    }, [location.pathname]);

    return <Orders
        key={currentViewType}
        userModel={userModel}
        supplierModel={supplierModel}
        vendorModel={vendorModel}
        isOnline={uiContext.isOnline}
        socket={socket}
        notifyFn={uiContext.notifyFn}
        toggleSidebar={uiContext.toggleSidebar}
        setSidebarComponent={uiContext.setSidebarComponent}
        setActivityIndicator={uiContext.setActivityIndicator}
        toggleMenu={uiContext.toggleMenu}
        history={navigate}
        location={location}
        intl={intl}
        showHiddenFeatures={uiContext.showHiddenFeatures}
        is_quotes={props.isQuotes}
        is_templates={props.isTemplates}
    />;
};
